import { Menu } from 'components'
import { useAuth, useStorage } from 'hooks'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useContext, useEffect } from 'react'
import { hasAccess, optionsLevels } from 'helper/utils'
import { GeneralContext } from 'context/generalContext'
import Container from './style'

export default function PrivateRoute() {
  const auth = useAuth()
  const location = useLocation()
  // const { user } = useContext(GeneralContext)
  // const [token] = useStorage('Token')
  // const general = useContext(GeneralContext)
  const [user] = useStorage('User')
  // const currentToken = auth.token?.split('.')[1]

  const base64Url = auth.token?.split('.')[1]
  const base64 = base64Url?.replace(/-/g, '+')?.replace(/_/g, '/')

  // Adiciona o padding necessário para múltiplos de 4
  const paddedBase64 = base64?.padEnd(
    base64.length + ((4 - (base64.length % 4)) % 4),
    '='
  )

  const decodedToken = paddedBase64 ? JSON.parse(atob(paddedBase64)) : undefined
  const isExpired = decodedToken?.exp && decodedToken.exp < Date.now() / 1000

  if (!decodedToken) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }
  if (isExpired) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // useEffect(() => {
  //   const token = window.sessionStorage.getItem('Token')
  //   console.log('chamando denovo')
  //   general.gestor.syncronize(token)
  // }, [])

  // if (
  //   /dashboard/i.test(location.pathname) &&
  //   ![
  //     'OWNER',
  //     'DIRECTOR',
  //     'GESTOR',
  //     'SPECIALIST',
  //     // 'FINANCIAL',
  //     'LEGAL',
  //     'SPECGESTOR',
  //   ].includes(optionsLevels[user.level])
  // ) {
  //   return <Navigate to="/dashboard" state={{ from: location }} replace />
  // }

  if (
    /clientes/i.test(location.pathname) &&
    !hasAccess('clients')
    // ![
    //   'OWNER',
    //   'DIRECTOR',
    //   'GESTOR',
    //   'SPECIALIST',
    //   'FINANCIAL',
    //   'LEGAL',
    //   'SPECGESTOR',
    // ].includes(optionsLevels[user.level])
  ) {
    return <Navigate to="/dashboard" state={{ from: location }} replace />
  }

  if (
    /produtos/i.test(location.pathname) &&
    // !['OWNER', 'DIRECTOR', 'GESTOR', 'FINANCIAL', 'SPECGESTOR'].includes(
    //   optionsLevels[user.level]
    // )
    !hasAccess('products')
  ) {
    return <Navigate to="/dashboard" state={{ from: location }} replace />
  }

  if (
    /colaboradores/i.test(location.pathname) &&
    // !['OWNER', 'RH'].includes(optionsLevels[user.level])
    !hasAccess('gestors')
  ) {
    return <Navigate to="/dashboard" state={{ from: location }} replace />
  }

  if (
    /financeiro/i.test(location.pathname) &&
    // !['OWNER', 'FINANCIAL'].includes(optionsLevels[user.level])
    !hasAccess('financial')
  ) {
    return <Navigate to="/dashboard" state={{ from: location }} replace />
  }

  return (
    <Container>
      <Menu />
      <Outlet />
    </Container>
  )
}
